import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
	HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { environment } from '../../environments/environment';

@Injectable()
export class AwsService {

	protected basePath = environment.demoApi;
	public defaultHeaders = new HttpHeaders();
	public configuration = new Configuration();

	constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
		if (basePath) {
			this.basePath = basePath;
		}
		if (configuration) {
			this.configuration = configuration;
			this.basePath = basePath || configuration.basePath || this.basePath;
		}
	}

	public documentS3Upload(url?: string, file?: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
	public documentS3Upload(url?: string, file?: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	public documentS3Upload(url?: string, file?: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	public documentS3Upload(url?: string, file?: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
		if (url === null || url === undefined) {
			throw new Error('Required parameter url was null or undefined when calling documentS3Upload.');
		}
		if (file === null || file === undefined) {
			throw new Error('Required parameter file was null or undefined when calling documentS3Upload.');
		}
		if (file === null || file === undefined) {
    			throw new Error('Required parameter file was null or undefined when calling documentS3Upload.');
		}

		let headers = this.defaultHeaders;
		headers = headers.set('Content-Type', file.type);

		return this.httpClient.request<any>('put', url,
			{
				body: file,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	public getBlob(url?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
	public getBlob(url?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	public getBlob(url?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	public getBlob(url?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
		if (url === null || url === undefined) {
			throw new Error('Required parameter url was null or undefined when calling documentS3Upload.');
		}

		let headers = this.defaultHeaders;
		headers = headers.set('Content-Type', 'blob');

		return this.httpClient.request<any>('get', url,
			{
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}
}
